import * as Yup from 'yup'

import { Form, Formik } from 'formik'
import { Trans, t } from '@lingui/macro'

import { Box } from 'rebass'
import Fab from './fab'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MuiTextField from '@material-ui/core/TextField'
import React from 'react'
import { compose } from 'recompose'
import fetch from 'isomorphic-unfetch'
import { withI18n } from '@lingui/react'
import { withSnackbar } from 'notistack'
import { withStyles } from '@material-ui/core/styles'

const TextField = withStyles({
  root: {
    '& > div': {
      background: 'white',
    },
  },
})(MuiTextField)

const ContactForm = ({ i18n, locale, enqueueSnackbar }) => {
  return (
    <Formik
      initialValues={{
        name: '',
        email: '',
        phone: '',
        text: '',
        locale,
      }}
      onSubmit={(values, { resetForm, setErrors, setSubmitting }) => {
        fetch('/.netlify/functions/contact', {
          method: 'POST',
          body: JSON.stringify(values),
        })
          .then(res => {
            setSubmitting(false)

            if (res.ok || res.status) {
              return res.json()
            }

            throw new Error('Network response was not ok.')
          })
          .then(({ err, errors, ...res }) => {
            if (err) {
              throw new Error(err)
            } else if (errors) {
              setErrors(errors)
            } else {
              resetForm()

              enqueueSnackbar(i18n._(t`Váš dotaz byl úspěšně odeslán :)`), {
                variant: 'success',
              })

              window.gtag &&
                window.gtag('event', 'conversion', {
                  send_to: `${
                    process.env.GATSBY_AW_CONVERSION_ID
                  }/dGh_CNDO_dcBEPb50aQC`,
                })

              window.fbq && window.fbq('track', 'Lead')
            }
          })
          .catch(err => {
            enqueueSnackbar(err.message, { variant: 'error' })
          })
      }}
      validationSchema={() => {
        return Yup.object().shape({
          name: Yup.string().required(
            i18n._(t`Prosím zadejte Vaše celé jméno.`)
          ),
          email: Yup.string()
            .email(i18n._(t`Nevalidní emailová adresa`))
            .required(
              i18n._(
                t`Prosím zadejte platný email, na který Vám můžeme odpovědět.`
              )
            ),
          text: Yup.string().required(i18n._(t`Prosím zadejte Váš dotaz.`)),
        })
      }}
    >
      {({ errors, handleChange, isSubmitting, values }) => {
        return (
          <Form>
            <Box>
              <TextField
                error={!!errors.name}
                fullWidth
                helperText={errors.name}
                label={i18n._(t`Jméno`)}
                margin="normal"
                name="name"
                onChange={handleChange}
                value={values.name}
                variant="outlined"
              />
            </Box>
            <Box>
              <TextField
                autoComplete="email"
                error={!!errors.email}
                fullWidth
                helperText={errors.email}
                label={i18n._(t`E-mail`)}
                margin="normal"
                name="email"
                onChange={handleChange}
                type="email"
                value={values.email}
                variant="outlined"
              />
            </Box>
            <Box>
              <TextField
                autoComplete="tel"
                fullWidth
                label={i18n._(t`Telefon`)}
                margin="normal"
                name="phone"
                onChange={handleChange}
                type="tel"
                value={values.phone}
                variant="outlined"
              />
            </Box>
            <Box>
              <TextField
                error={!!errors.text}
                fullWidth
                helperText={errors.text}
                label={i18n._(t`Váš dotaz`)}
                margin="normal"
                multiline
                name="text"
                onChange={handleChange}
                value={values.text}
                variant="outlined"
              />
            </Box>
            <Box mt={3}>
              <Fab
                color="primary"
                disabled={isSubmitting}
                type="submit"
                variant="extended"
              >
                <FontAwesomeIcon
                  fixedWidth
                  icon={isSubmitting ? 'cog' : 'paper-plane'}
                  spin={isSubmitting}
                />
                <Trans>Odeslat</Trans>
              </Fab>
            </Box>
          </Form>
        )
      }}
    </Formik>
  )
}

export default compose(
  withI18n(),
  withSnackbar
)(ContactForm)
